/** Permissions required for KYC media capture inside nested iframes. */
export const IFRAME_MEDIA_ALLOW =
  "microphone *;camera *;midi *;encrypted-media *;clipboard-read;clipboard-write;";

export function applyMediaAllowToIframes(root = document) {
  if (!root?.querySelectorAll) {
    return;
  }
  root.querySelectorAll("iframe").forEach((iframe) => {
    iframe.setAttribute("allow", IFRAME_MEDIA_ALLOW);
    iframe.allow = IFRAME_MEDIA_ALLOW;
  });
}

/** Ask the parent embedder (e.g. RocketFuel SDK) to grant media on the payment iframe. */
export function requestEmbedderMediaPermissions() {
  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        { type: "rocketfuel_request_media_permissions" },
        "*"
      );
    }
  } catch {
    // cross-origin parent
  }
}
